export const truncateAndRemoveImages = (html: string, maxLength?: number) => {

    const withoutImages = html?.replace(/<img[^>]*>/g, "");
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = withoutImages || "";
    const textContent = tempDiv.textContent || tempDiv.innerText || "";
    const truncatedText = textContent.substring(0, maxLength);
    const result = truncatedText + (textContent.length > maxLength ? "..." : "");

    return result;
};

export function truncateText(text, maxLength) {
    if (text?.length > maxLength) {
        return text.substring(0, maxLength) + '...';
    }
    return text;
}
